<template>
  <v-bottom-sheet :value="getActivador" fullscreen>
    <v-sheet class="text-center py-5" style="background-color:#F8F100;">
    <p class="pt-5 pb-2 title" v-if="!safari">{{$t('Inicio.Pwa')}}</p>
    <p class="pt-5 pb-2 title" v-else>{{$t('Inicio.PwaSafari')}}</p>
    <v-btn @click="setActivador(false)" class="ma-3" color="black" style="border:2px solid" outlined x-large>{{$t('Formularios.Cerrar')}}</v-btn>
    <v-btn @click="activar" class="ma-3" color="black white--text" x-large v-if="!safari">{{$t('Inicio.Instalar')}}</v-btn>
    </v-sheet>
  </v-bottom-sheet>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
export default {
  props: ['activador'],
  name: 'Pwa',
  data () {
    return {
      safari: false
    }
  },
  mounted () {
    // Detects if device is on iOS
    const isIos = () => {
      const userAgent = window.navigator.userAgent.toLowerCase()
      return /iphone|ipad|ipod/.test(userAgent)
    }
    // Detects if device is in standalone mode
    const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone)
    // Checks if should display install popup notification:
    if (isIos() && !isInStandaloneMode()) {
      this.safari = true
    }
  },
  methods: {
    ...mapMutations(['activarPwa', 'setActivador']),
    activar () {
      this.setActivador(false)
      this.activarPwa()
    }
  },
  computed: {
    ...mapGetters(['getActivador'])
  }
}
</script>
